"use client"

import { useEffect, useState } from "react"
import { usePathname } from "next/navigation"
import { hasCookieConsent, COOKIE_CONSENT_EVENT } from "@/components/cookie-consent-banner"

declare global {
  interface Window {
    ym?: (id: number, method: string, ...args: unknown[]) => void
  }
}

export function YandexMetrika() {
  const pathname = usePathname()
  const [consented, setConsented] = useState(false)

  // Метрика нужна только на публичных страницах (лендинг, about, pricing и т.д.)
  // Не нужна в ЛК и админке
  const isPublicPage = !pathname.startsWith("/lk") && !pathname.startsWith("/admin")

  useEffect(() => {
    setConsented(hasCookieConsent())
    const handler = () => setConsented(true)
    window.addEventListener(COOKIE_CONSENT_EVENT, handler)
    return () => window.removeEventListener(COOKIE_CONSENT_EVENT, handler)
  }, [])

  useEffect(() => {
    // 152-ФЗ / РКН: не загружаем Метрику до явного согласия пользователя
    if (!isPublicPage || !consented) return

    const scriptId = "yandex-metrika"
    if (document.getElementById(scriptId)) return

    const script = document.createElement("script")
    script.id = scriptId
    script.type = "text/javascript"
    script.innerHTML = `
      (function(m,e,t,r,i,k,a){
        m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
        m[i].l=1*new Date();
        for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
        k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
      })(window, document,'script','https://mc.yandex.ru/metrika/tag.js?id=106550268', 'ym');
      ym(106550268, 'init', {ssr:true, webvisor:true, clickmap:true, ecommerce:"dataLayer", referrer: document.referrer, url: location.href, accurateTrackBounce:true, trackLinks:true});
    `
    document.head.appendChild(script)
  }, [isPublicPage, consented])

  return null
}
